import { render, staticRenderFns } from "./AddAsset.vue?vue&type=template&id=cd61b5a0&"
import script from "./AddAsset.vue?vue&type=script&lang=ts&"
export * from "./AddAsset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports